import { render, staticRenderFns } from "./SchulungDetail.vue?vue&type=template&id=d013e5d8&scoped=true"
import script from "./SchulungDetail.vue?vue&type=script&lang=js"
export * from "./SchulungDetail.vue?vue&type=script&lang=js"
import style0 from "./SchulungDetail.vue?vue&type=style&index=0&id=d013e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d013e5d8",
  null
  
)

export default component.exports